import React, { PureComponent, ReactNode } from 'react';
import { Input } from 'antd';
import { LOCAL_ID_PREFIX } from '../../constants';
import { medicalHistoryOptions } from './CustomiseSections';
import { PAD_V2_CONTAINER } from '../prescriptionPad/rightPanel/workspace/PadContainer';
import { MEDICAL_HISTORY_CATEGORY, MHItem2 } from '../../store/types/medicalHistory';
import { MEDICAL_HISTORY_CONTAINER } from '../prescriptionPad/rightPanel/workspace/MedicalHistoryContainer';
import { getGenieSetting } from '../../store/selectors/session';
import { GlobalState } from '../../store/reducers';
import { connect } from 'react-redux';

const { TextArea } = Input;
interface Props {
    setMedicalHistoryCommonItemsSectionData: (id: MEDICAL_HISTORY_CATEGORY, item: MHItem2) => void;
    selectedSection: MEDICAL_HISTORY_CATEGORY;
    isMedicalHistorySection?: boolean;
    disableAutoScrollOnSelect?: boolean;
}

type State = {
    notes: string;
};

class MedicalHistoryInputContainer extends PureComponent<Props> {
    state: State = {
        notes: '',
    };

    TARGET_CONTAINER = this.props.isMedicalHistorySection
        ? MEDICAL_HISTORY_CONTAINER
        : PAD_V2_CONTAINER;
    elId = `MEDICAL_HISTORY_${this.props.selectedSection.toUpperCase()}`;

    saveRecentTravelHistory = (selectedSection: MEDICAL_HISTORY_CATEGORY, notes: string) => {
        notes &&
            this.props.setMedicalHistoryCommonItemsSectionData(selectedSection, {
                id: `${LOCAL_ID_PREFIX}${selectedSection}-${new Date().getTime()}`,
                name: 'Travel History',
                notes: notes,
            });
    };

    saveOtherMedicalHistory = (selectedSection: MEDICAL_HISTORY_CATEGORY, notes: string) => {
        notes &&
            this.props.setMedicalHistoryCommonItemsSectionData(selectedSection, {
                id: `${LOCAL_ID_PREFIX}${selectedSection}-${new Date().getTime()}`,
                name: notes,
            });
    };

    onSaveNotes = (): void => {
        const { selectedSection } = this.props;
        const { notes } = this.state;

        if (selectedSection === MEDICAL_HISTORY_CATEGORY.RECENT_TRAVEL_HISTORY) {
            this.saveRecentTravelHistory(selectedSection, notes);
        }
        if (selectedSection === MEDICAL_HISTORY_CATEGORY.OTHER_MEDICAL_HISTORY) {
            this.saveOtherMedicalHistory(selectedSection, notes);
        }

        this.setState({ notes: '' });
    };

    onEnter = (): void => {
        const { selectedSection } = this.props;
        const { notes } = this.state;

        if (selectedSection === MEDICAL_HISTORY_CATEGORY.OTHER_MEDICAL_HISTORY) {
            this.saveOtherMedicalHistory(selectedSection, notes);
            this.setState({ notes: '' });
        }
    };

    onTextChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        this.setState({ notes: e.target.value });
    };

    adjustScroll = (): void => {
        if (!this.elId || this.props.disableAutoScrollOnSelect) {
            return;
        }

        const el = document.getElementById(this.elId) as HTMLDivElement;
        const con = document.getElementById(this.TARGET_CONTAINER) as HTMLDivElement;

        if (el && con) {
            const diff = 80 - (con.offsetHeight - (294 + el.getBoundingClientRect().y));
            diff > 0 &&
                con.scrollBy({
                    top: diff,
                    behavior: 'smooth',
                });
        }
    };

    onInputFocus = (): void => {
        this.adjustScroll();
    };

    render(): ReactNode {
        const { selectedSection } = this.props;
        const DisplayComponent =
            selectedSection === MEDICAL_HISTORY_CATEGORY.RECENT_TRAVEL_HISTORY ? TextArea : Input;

        return (
            <div className="flex flex-col mt-20">
                <p className="whitespace-nowrap body-1  pb-4 font-700 text-darwin-neutral-800">
                    {medicalHistoryOptions[selectedSection]?.inputContainerOptions?.heading}
                </p>
                <div>
                    <DisplayComponent
                        id={this.elId}
                        onFocus={this.onInputFocus}
                        placeholder={
                            medicalHistoryOptions[selectedSection]?.inputContainerOptions?.text
                        }
                        allowClear
                        bordered
                        value={this.state.notes}
                        onChange={this.onTextChange}
                        onPressEnter={this.onEnter}
                        onBlur={this.onSaveNotes}
                    />
                </div>
            </div>
        );
    }
}

export default connect((state: GlobalState) => ({
    disableAutoScrollOnSelect: getGenieSetting(state, 'disableAutoScrollOnSelect') as boolean,
}))(MedicalHistoryInputContainer);
